export const MODE_SINGLE_STEP = 'singleStep';
export const MODE_CONTINUOUS = 'continuous';

export const timeline: UI.Timeline = {
  fastForwardPace: 3,
  fastBackwardPace: -3,
  isPlaying: false,
  defaultSpeed: 1,
  speed: 1,
  progress: 0,
  currentTime: 0,
  targetTime: -1,
  totalTime: -1,
  windingSpeedOnMultiPageChange: 3,
  windingSpeedOnSinglePageChange: 3,
  mode: MODE_CONTINUOUS,
  reset: false,
};
